import type { PhysicsStore } from "../core/store.js";

export interface EvalContext {
  store: PhysicsStore;
}

export function hasPerformedAction(ctx: EvalContext, stepId: string, actionId: string): boolean {
  return ctx.store.actionCount(stepId, actionId) > 0;
}

export function hasAllActions(ctx: EvalContext, stepId: string, actionIds: string[]): boolean {
  return actionIds.every((id) => hasPerformedAction(ctx, stepId, id));
}

export function hasAllRecordedFields(ctx: EvalContext, fieldIds: string[]): boolean {
  return fieldIds.every((id) => ctx.store.isRecorded(id));
}
